import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 498,
    },
    dialogTitle: {
      padding: `${theme.spacing(4)}px ${theme.spacing(4)}px ${theme.spacing(2)}px !important`,
      borderBottom: 'unset !important',
    },
    title: {
      ...theme.typography.semiBold16,
      fontWeight: theme.typography.fontWeightBold,
      color: COLORS.gray.black,
    },
    dialogContent: {
      padding: `${theme.spacing(2)}px ${theme.spacing(5)}px ${theme.spacing(4)}px !important`,
    },
    inputLabel: {
      color: COLORS.gray.black,
    },
    description: {
      color: COLORS.gray.gray40,
      display: 'flex',
      columnGap: theme.spacing(0.25),
    },
    field: {
      width: '100%',
      margin: theme.spacing(1, 0, 0.5),
    },
    dialogActions: {
      padding: `${theme.spacing(2)}px ${theme.spacing(5)}px !important`,
    },
    buttonCancel: {},
    buttonSubmit: {
      minWidth: 'unset',
    },
  }),
  { name: 'BranVoicePopup' }
);
